import '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import { noop } from '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import { cssVars, toTransformOrigin, getBoxShadow } from './popper.utils.esm.js';

var matchWidth = {
  name: 'matchWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: function fn(_ref) {
    var state = _ref.state;
    // eslint-disable-next-line no-param-reassign
    state.styles.popper.width = state.rects.reference.width + "px";
  },
  effect: function effect(_ref2) {
    var state = _ref2.state;
    var reference = state.elements.reference; // eslint-disable-next-line no-param-reassign

    state.elements.popper.style.width = reference.offsetWidth + "px";
    return noop;
  }
};

var setTransformOrigin = function setTransformOrigin(state) {
  state.elements.popper.style.setProperty(cssVars.transformOrigin["var"], toTransformOrigin(state.placement));
};

var transformOrigin = {
  name: 'transformOrigin',
  enabled: true,
  phase: 'write',
  fn: function fn(_ref3) {
    var state = _ref3.state;
    setTransformOrigin(state);
  },
  effect: function effect(_ref4) {
    var state = _ref4.state;
    return function () {
      setTransformOrigin(state);
    };
  }
};

var getArrowStyle = function getArrowStyle(placement) {
  if (placement.startsWith('top')) {
    return {
      property: 'bottom',
      value: cssVars.arrowOffset.varRef
    };
  }

  if (placement.startsWith('bottom')) {
    return {
      property: 'top',
      value: cssVars.arrowOffset.varRef
    };
  }

  if (placement.startsWith('left')) {
    return {
      property: 'right',
      value: cssVars.arrowOffset.varRef
    };
  }

  if (placement.startsWith('right')) {
    return {
      property: 'left',
      value: cssVars.arrowOffset.varRef
    };
  }

  return {
    property: 'bottom',
    value: cssVars.arrowOffset.varRef
  };
};

var setArrowStyles = function setArrowStyles(state) {
  var _state$elements;

  if (!state.placement) return;
  var overrides = getArrowStyle(state.placement);

  if (((_state$elements = state.elements) == null ? void 0 : _state$elements.arrow) && overrides) {
    var _Object$assign, _vars;

    Object.assign(state.elements.arrow.style, (_Object$assign = {}, _Object$assign[overrides.property] = overrides.value, _Object$assign.width = cssVars.arrowSize.varRef, _Object$assign.height = cssVars.arrowSize.varRef, _Object$assign.zIndex = -1, _Object$assign));
    var vars = (_vars = {}, _vars[cssVars.arrowSizeHalf["var"]] = "calc(" + cssVars.arrowSize.varRef + " / 2)", _vars[cssVars.arrowOffset["var"]] = "calc(" + cssVars.arrowSizeHalf.varRef + " * -1)", _vars);
    Object.keys(vars).forEach(function (property) {
      var _state$elements2, _state$elements2$arro;

      (_state$elements2 = state.elements) == null ? void 0 : (_state$elements2$arro = _state$elements2.arrow) == null ? void 0 : _state$elements2$arro.style.setProperty(property, vars[property]);
    });
  }
};

var positionArrow = {
  name: 'positionArrow',
  enabled: true,
  phase: 'afterWrite',
  fn: function fn(_ref5) {
    var state = _ref5.state;
    setArrowStyles(state);
  }
};

var setInnerArrowStyles = function setInnerArrowStyles(state) {
  if (!state.elements.arrow) return;
  var inner = state.elements.arrow.querySelector('[data-popper-arrow-inner]');
  if (!inner) return;
  Object.assign(inner.style, {
    transform: 'rotate(45deg)',
    // background: cssVars.arrowBg.varRef,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    position: 'absolute',
    zIndex: 'inherit',
    boxShadow: getBoxShadow(state.placement, cssVars.arrowShadowColor.varRef)
  });
};

var innerArrow = {
  name: 'innerArrow',
  enabled: true,
  phase: 'main',
  requires: ['arrow'],
  fn: function fn(_ref6) {
    var state = _ref6.state;
    setInnerArrowStyles(state);
  },
  effect: function effect(_ref7) {
    var state = _ref7.state;
    return function () {
      setInnerArrowStyles(state);
    };
  }
};

export { innerArrow, matchWidth, positionArrow, transformOrigin };
//# sourceMappingURL=popper.modifiers.esm.js.map
